import React, { useEffect, useState } from "react";
// import ApiService from "../../utils/ApiService";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import { Button, Dropdown, Menu, Pagination, Row, Spin } from "antd";
import moment from "moment";

import Swal from "sweetalert2";

import inquiryApi from "../../apis/Inquiry.api";
import LinkComponent from "../../components/layout/LinkComponent";
import UserManageNav from "../../components/userManageGroup/userManageNav";
import { setLoading } from "../../redux/store/common/commonDuck";

// const api = new ApiService();
const InquiryManage = () => {
	const history = useHistory();
	const dispatch = useDispatch();

	const user = useSelector((state) => state.auth.user);
	const isLoading = useSelector((state) => state.common.loading);
	const setIsLoading = (value) => dispatch(setLoading(value));

	const pageSize = 10;
	const [currentPageNumber, setCurrentPageNumber] = useState(1);
	const [totalCount, setTotalCount] = useState(0);

	const [filterName, setFilterName] = useState({
		value: "all",
		name: "모두보기",
	});

	const [inquiryList, setInquiryList] = useState([]);

	/**
	 * page 넘김
	 */
	const handleChangePagination = async (pageNumber) => {
		// const currOffset = (pageNumber - 1) * pageSize;
		setCurrentPageNumber(pageNumber);
	};

	const filterList = [
		{
			value: "total",
			name: "모두보기",
		},
		{
			value: "waiting",
			name: "답변예정",
		},
		{
			value: "answer",
			name: "답변완료",
		},
	];

	const dropdownFilter = (
		<Menu>
			{filterList?.map((item, idx) => (
				<Menu.Item
					onClick={() => setFilterName(item)}
					key={`${item.value}-${idx}`}
					className={`${
						item.value === filterName.value ? "inquiry-filter-item" : ""
					}`}
				>
					{item?.name}
				</Menu.Item>
			))}
		</Menu>
	);

	useEffect(() => {
		window.scrollTo({
			top: 0,
		});
	}, []);

	useEffect(() => {
		if (user?.id) {
			getInquiryList();
		}
	}, [user, currentPageNumber, filterName]);

	/**
	 * admin: 추천 상담 게시판
	 * @returns {Promise<void>}
	 */
	const getInquiryList = async () => {
		setIsLoading(true);
		const param = {
			offset: (currentPageNumber - 1) * pageSize,
			pageSize: pageSize,
			influencerId:
				user?.role === "level_1" || user?.role === "super_admin"
					? user?.id
					: user?.partners_id,
			// userId: user?.id,
			userId:
				user?.role === "level_1" || user?.role === "super_admin"
					? user?.id
					: user?.partners_id,
			answerStatus: filterName?.value,
		};

		const res = await inquiryApi.adminReadInquiryList(param);
		if (res.code === 200) {
			setTotalCount(res.result?.totalCnt);
			setInquiryList(res.result?.inquiryList);
			setIsLoading(false);
		} else {
			// window.alert("오류가 발생했습니다. 잠시 후에 다시 시도해주세요.");
			setTotalCount(0);
			setInquiryList([]);
			console.log("get-inquiry-list-error");
			setIsLoading(false);
		}
	};

	const pageMove = (item) => {
		history.push(`/inquiry_manage/${item?.id}`);
	};

	/**
	 * 질문/답변 모두 삭제
	 * @returns {Promise<void>}
	 */
	const deleteInquiryAll = async (item) => {
		Swal.fire({
			customClass: "alert-custom",
			text: `해당 글을 삭제하시겠습니까?`,
			showCancelButton: true,
			confirmButtonText: "확인",
			cancelButtonText: "취소",
		}).then(async (result) => {
			if (result.isConfirmed) {
				setIsLoading(true);
				const param = {
					inquiryId: item?.id,
					// influencerId: user?.id,
					// userId: user?.id,
					influencerId:
						user?.role === "level_1" || user?.role === "super_admin"
							? user?.id
							: user?.partners_id,
					userId:
						user?.role === "level_1" || user?.role === "super_admin"
							? user?.id
							: user?.partners_id,
				};
				const res = await inquiryApi.adminDeleteInquiryAll(param);
				if (res.code === 200) {
					Swal.fire({
						customClass: "alert-custom",
						text: "성공적으로 삭제되었습니다!",
						confirmButtonText: "확인",
					}).then(() => {
						if (totalCount - 1 <= (currentPageNumber - 1) * pageSize) {
							setCurrentPageNumber(currentPageNumber - 1);
						} else {
							getInquiryList();
						}
						setIsLoading(false);
					});
				} else {
					Swal.fire({
						customClass: "alert-custom",
						text: "오류가 발생했습니다. 잠시 후 다시 시도해주세요.",
						confirmButtonText: "확인",
					}).then(() => {
						console.log("delete-inquiry-list-error");
						setIsLoading(false);
					});
				}
			}
		});
	};

	return (
		<div className="main-wrap">
			<div className="max-width-apply">
				<LinkComponent />

				<h1 className="main-title">회원 관리</h1>

				<UserManageNav />

				{/* 추천 상담 게시판 */}
				{isLoading && (
					<Spin
						style={{
							margin: "auto",
							width: "100%",
							paddingTop: "2em",
							position: "absolute",
							left: 0,
							right: 0,
						}}
					/>
				)}
				<div className={`main-body`}>
					<div
						style={{
							display: "flex",
							alignItems: "center",
							justifyContent: "space-between",
						}}
					>
						<h3 className={`body-title`}>추천 상담 게시판</h3>
					</div>
					<div className={`inquiry-manage-table`}>
						<div className={`inquiry-manage-title`}>
							<Dropdown
								overlay={dropdownFilter}
								trigger={["click"]}
								// disabled={directly}
							>
								<button
									className={`table-title`}
									style={{ display: "flex", alignItems: "center", gap: "3px" }}
									disabled={isLoading}
								>
									{filterName?.name ?? "모두보기"}
									<img
										src={`/assets/images/report/report-search-date-icon-down.png`}
										alt={`드롭다운`}
										style={{
											height: "auto",
											width: "0.8em",
										}}
									/>
								</button>
							</Dropdown>
							<p className={`table-title`}>문의사항</p>
							<p className={`table-title`}>작성자</p>
							<p className={`table-title`}>작성일</p>
							<p className={`table-title`} />
						</div>

						{inquiryList?.length ? (
							<>
								{inquiryList?.map((item, idx) => (
									<div
										className={`inquiry-manage-body`}
										key={`inquiry-manage-${idx}`}
									>
										<p className={`table-title`}>
											<span
												className={`table-border ${
													item?.is_answer ? "success" : ""
												}`}
											>
												{item?.is_answer ? "답변완료" : "답변예정"}
											</span>
										</p>
										<p
											className={`table-title`}
											style={{ cursor: "pointer" }}
											onClick={() => pageMove(item)}
										>
											{item?.is_secret ? (
												<>
													<img
														src={`/assets/images/channel/secret-black.png`}
														alt={`비밀댓글`}
														style={{
															width: "0.9em",
															height: "auto",
															marginRight: "3px",
														}}
													/>
													{item?.title}
												</>
											) : (
												<>{item?.title}</>
											)}
										</p>
										<p className={`table-title`}>{item?.created_by_name}</p>
										<p className={`table-title`}>
											{moment(item?.created_at).format("YYYY.MM.DD")}
										</p>
										<div className={`table-title button-group`}>
											<Button
												onClick={() => deleteInquiryAll(item)}
												disabled={isLoading}
											>
												삭제
											</Button>
											{item?.is_answer ? (
												<Button
													onClick={() => pageMove(item)}
													disabled={isLoading}
												>
													수정하기
												</Button>
											) : (
												<Button
													className={`black`}
													onClick={() => pageMove(item)}
													disabled={isLoading}
												>
													답변하기
												</Button>
											)}
										</div>
									</div>
								))}
							</>
						) : (
							<Row
								align={"middle"}
								style={{
									width: "100%",
									flexDirection: "column",
									padding: "3em 0",
								}}
							>
								<img
									src={`/assets/images/warning.png`}
									alt={`warning-icon`}
									style={{
										width: "3.5em",
										height: "auto",
									}}
								/>
								<p
									style={{
										marginTop: "1em",
										color: "#adb5bd",
										fontSize: "1.2em",
										fontWeight: 500,
									}}
								>
									일치하는 내용이 없습니다.
								</p>
							</Row>
						)}
					</div>

					{!!inquiryList?.length && (
						<Pagination
							className="report-pagination-wrap"
							showSizeChanger={false}
							current={currentPageNumber}
							pageSize={pageSize}
							total={totalCount}
							onChange={handleChangePagination}
						/>
					)}
				</div>
			</div>
		</div>
	);
};
export default InquiryManage;
